module.exports = __webpack_public_path__ + "img/gallery13.22226bf.jpg";